'use client'

import { useParams, useSearchParams } from 'react-router-dom'
import { getAvatarAssets, type AvatarKey } from './config/avatars'
import { ChatAvatar } from './ChatAvatar'
import { useIsMobile } from '@/hooks/useIsMobile'
import { getVarsFromSearchParams } from './utils'

export default function AvatarPlaygroundPage() {
  const { componentId } = useParams()
  let [searchParams] = useSearchParams()
  const avatarKey = (searchParams.get('avatar') || 'robot') as AvatarKey
  const personaId = searchParams.get('persona_id')
  const imageFrame = searchParams.get('imageFrame')
  const isEnabledSubtitles = searchParams.get('isEnabledSubtitles') !== 'false'
  const isMobile = useIsMobile()

  try {
    const avatarAssets = getAvatarAssets(avatarKey)
    const contextValues = getVarsFromSearchParams(searchParams)

    return (
      <div
        className={`min-h-screen ${isMobile ? 'w-screen flex flex-col items-center justify-between p-0 m-0' : 'w-full'}`}
      >
        <ChatAvatar
          componentId={componentId!}
          personaId={personaId || undefined}
          contextValues={contextValues}
          avatarAssets={avatarAssets}
          imageFrame={imageFrame || undefined}
          isEnabledSubtitles={isEnabledSubtitles}
        />
      </div>
    )
  } catch (error) {
    return <div className="p-4 text-red-500">Could not find avatar: {avatarKey}</div>
  }
}
